<template>
  <div class="onboarding-static-page-container">
      <OnboardingMenu class="menu" :logo="logoUrl" :languages="languageOptions" :menus="menuOptions"></OnboardingMenu>
      <div class="header">
        <p class="title">{{ $t('onboarding.nestle.landingPage.title') }}</p>
        <p class="subtitle">{{ $t('onboarding.nestle.landingPage.subtitle') }}</p>
      </div>
      <div class="body">
        <div class="description">
            <p>{{ $t('onboarding.nestle.landingPage.introduction') }}</p>
            <p class="sub-introduction">{{ $t('onboarding.nestle.landingPage.subIntroduction') }}</p>
            <div class="dividing-line"></div>
        </div>
        <div class="video-board">
          <div class="board-body">
            <div class="board-video">
              <div v-show="showVideoImage" class="board-video-preview-image" @click="playVideo()">
                <img :src="previewImgUrl" alt="">
                <img :src="playIcon" class="board-video-play-icon">
              </div>
              <video ref="video" v-show="!showVideoImage" controls>
                <source src="https://static-c.ajinga.com/nestle/MSchneider_message.mp4" type="video/mp4" />
                <!-- <track src="/vue-static/vtt/MSchneider_message_subtitlesEN.vtt" kind="subtitles" srclang="en" label="EN" default />
                <track src="/vue-static/vtt/MSchneider_message_subtitlesCN.vtt" kind="subtitles" srclang="zh" label="ZH" />
                <track src="/vue-static/vtt/MSchneider_message_subtitlesTW.vtt" kind="subtitles" srclang="zh" label="TW" /> -->
              </video>
            </div>
            <div class="board-content">
              <p class="board-title">{{ $t('onboarding.nestle.landingPage.welcome') }}</p>
              <p class="board-description">{{ $t('onboarding.nestle.landingPage.welcomeDescription') }}</p>
              <p class="board-ceo">{{ $t('onboarding.nestle.landingPage.ourCEO') }}</p>
            </div>
          </div>
        </div>
        <div class="image-board clear-margin-top"  @click="toPage('paperwork')">
            <img :src="paperworkImgUrl" alt="">
            <div class="content">
              <p class="board-title">{{ $t('onboarding.nestle.landingPage.paperwork') }}</p>
              <p class="board-subtitle">{{ $t('onboarding.nestle.landingPage.paperworkDescription') }}</p>
            </div>
        </div>
        <div class="image-board flex-derection-row-reverse"  @click="toPage('myFirstDay')">
            <img :src="myFirstDayImgUrl" alt="">
            <div class="content">
              <p class="board-title">{{ $t('onboarding.nestle.landingPage.myFirstDay') }}</p>
              <p class="board-subtitle">{{ $t('onboarding.nestle.landingPage.myFirstDayDescription') }}</p>
            </div>
        </div>
        <div class="image-board"  @click="toPage('learning')">
            <img :src="learningImgUrl" alt="">
            <div class="content">
              <p class="board-title">{{ $t('onboarding.nestle.landingPage.learning') }}</p>
              <p class="board-subtitle">{{ $t('onboarding.nestle.landingPage.learningDescription') }}</p>
            </div>
        </div>
        <div class="video-board" v-for="(item, index) in customVideosAndImg.customVideos" v-bind:key="'video'+index">
          <div class="board-body">
            <div class="board-video">
              <div v-show="item.showVideoImage" class="board-video-preview-image" @click="playVideo(index)">
                <img :src="item.previewImg" alt="">
                <img :src="playIcon" class="board-video-play-icon">
              </div>
              <video ref="customVideos" v-show="!item.showVideoImage" controls>
                <source :src="item.video" type="video/mp4" />
                <track v-for="(subtitles, index) in item.videoSubTitles" v-bind:key="'subtitles'+index" :src="subtitles.src" kind="subtitles" :srclang="subtitles.srclang" :label="subtitles.label" :default="index===0"/>
              </video>
            </div>
            <div class="board-content">
              <p class="board-title">{{ $t(`${item.title}`) }}</p>
              <p class="board-description">{{ $t(`${item.subtitle}`) }}</p>
            </div>
          </div>
        </div>
        <div class="image-board" v-for="(item, index) in customVideosAndImg.customImgs" v-bind:key="'img'+index" @click="item.isVuePage ? toVuePage({ path: item.link }, true) : toOutSide(item.link)">
            <img :src="item.img">
            <div class="content">
              <p class="board-title">{{ $t(`${item.title}`) }}</p>
              <p class="board-subtitle">{{ $t(`${item.subtitle}`) }}</p>
            </div>
        </div>
        <div class="follow">
          <p v-html="$t('onboarding.nestle.followUs')"></p>
          <p>{{ $t('onboarding.nestle.donnotBeShared') }}</p>
        </div>
        <onboarding-modal ref="modal" v-if="showWelcome" v-show="showWelcome" v-model="showWelcome" :title="welcomeModal['title']" :body="welcomeModal['body']" :footer="welcomeModal['footer']"></onboarding-modal>
      </div>
      <Footer></Footer>
  </div>
</template>

<script>
import { onboardingMixin } from '@/components/onboarding/form/mixin.js'
import OnboardingMenu from '@/components/onboarding/form/Menu'
import OnboardingModal from '@/components/onboarding/form/Modal'
import Footer from '@/components/onboarding/form/Footer'
import { deviceType } from '@/utils/common'

export default {
  mixins: [onboardingMixin],
  components: {
    OnboardingMenu, Footer, OnboardingModal
  },
  data () {
    const isMobile = deviceType.isMobile
    return {
      previewImgUrl: require(isMobile ? '@/assets/image/onboarding/landing/h5/video.jpg' : '@/assets/image/onboarding/landing/pc/video.jpg'),
      paperworkImgUrl: require(isMobile ? '@/assets/image/onboarding/landing/h5/paperwork.jpg' : '@/assets/image/onboarding/landing/pc/paperwork.jpg'),
      myFirstDayImgUrl: require(isMobile ? '@/assets/image/onboarding/landing/h5/my-first-day.jpg' : '@/assets/image/onboarding/landing/pc/my-first-day.jpg'),
      learningImgUrl: require(isMobile ? '@/assets/image/onboarding/landing/h5/learning.jpg' : '@/assets/image/onboarding/landing/pc/learning.jpg'),
      showWelcome: false,
      showVideoImage: true,
      playIcon: require('@/assets/iconfont/icon-play.svg'),
      customVideosAndImg: {
        customVideos: [],
        customImgs: []
      },
      customVideosAndImg1: {
        customVideos: [
          {
            previewImg: require(isMobile ? '@/assets/image/onboarding/learning/h5/video-1.jpg' : '@/assets/image/onboarding/learning/pc/video-1.jpg'),
            video: 'https://static-c.ajinga.com/nestle/Waters_CEO.mp4',
            title: 'onboarding.nestle.learningPage.messageFromMaurizioPatarnello',
            subtitle: '',
            showVideoImage: true,
            videoSubTitles: [
              // {
              //   src: '/vue-static/vtt/Waters_CEO_subtitlesEN.vtt',
              //   label: 'EN',
              //   srclang: 'en'
              // },
              // {
              //   src: '/vue-static/vtt/Waters_CEO_subtitlesCN.vtt',
              //   label: 'CN',
              //   srclang: 'zh'
              // },
              // {
              //   src: '/vue-static/vtt/Waters_CEO_subtitlesTW.vtt',
              //   label: 'TW',
              //   srclang: 'zh'
              // }
            ]
          }
        ],
        customImgs: [
          {
            img: require(isMobile ? '@/assets/image/onboarding/learning/h5/video-7.jpg' : '@/assets/image/onboarding/learning/pc/video-7.jpg'),
            link: 'https://static-c.ajinga.com/nestle/Waters_Welcome.pdf',
            title: 'onboarding.nestle.learningPage.nestleWaters',
            subtitle: '',
            isVuePage: false
          }
        ]
      },
      customVideosAndImg2: {
        customVideos: [
          {
            previewImg: require(isMobile ? '@/assets/image/onboarding/learning/h5/video-6.jpg' : '@/assets/image/onboarding/learning/pc/video-6.jpg'),
            video: 'https://static-c.ajinga.com/nestle/CPW_About.mp4',
            title: 'onboarding.nestle.learningPage.cerealPartnersWorldwide',
            subtitle: '',
            showVideoImage: true,
            videoSubTitles: [
              // {
              //   src: '/vue-static/vtt/CPW_About_subtitlesEN.vtt',
              //   label: 'EN',
              //   srclang: 'en'
              // },
              // {
              //   src: '/vue-static/vtt/CPW_About_subtitlesCN.vtt',
              //   label: 'CN',
              //   srclang: 'zh'
              // },
              // {
              //   src: '/vue-static/vtt/CPW_About_subtitlesTW.vtt',
              //   label: 'TW',
              //   srclang: 'zh'
              // }
            ]
          }
        ],
        customImgs: []
      },
      customVideosAndImg3: {
        customVideos: [
          {
            previewImg: require(isMobile ? '@/assets/image/onboarding/learning/h5/video-3.jpg' : '@/assets/image/onboarding/learning/pc/video-3.jpg'),
            video: 'https://static-c.ajinga.com/nestle/Purina_CEO.mp4',
            title: 'onboarding.nestle.learningPage.messageFromJoeSivewright',
            subtitle: '',
            showVideoImage: true,
            videoSubTitles: [
              // {
              //   src: '/vue-static/vtt/Purina_CEO_subtitlesEN.vtt',
              //   label: 'EN',
              //   srclang: 'en'
              // }
            ]
          },
          {
            previewImg: require(isMobile ? '@/assets/image/onboarding/learning/h5/video-2.jpg' : '@/assets/image/onboarding/learning/pc/video-2.jpg'),
            video: 'https://static-c.ajinga.com/nestle/Purina_History.mp4',
            title: 'onboarding.nestle.learningPage.purinaHistory',
            subtitle: '',
            showVideoImage: true,
            videoSubTitles: [
              // {
              //   src: '/vue-static/vtt/Purina_History_subtitlesEN.vtt',
              //   label: 'EN',
              //   srclang: 'en'
              // },
              // {
              //   src: '/vue-static/vtt/Purina_History_subtitlesCN.vtt',
              //   label: 'CN',
              //   srclang: 'zh'
              // },
              // {
              //   src: '/vue-static/vtt/Purina_History_subtitlesTW.vtt',
              //   label: 'TW',
              //   srclang: 'zh'
              // }
            ]
          }
        ],
        customImgs: []
      },
      customVideosAndImg4: {
        customVideos: [
          {
            previewImg: require(isMobile ? '@/assets/image/onboarding/learning/h5/10.jpg' : '@/assets/image/onboarding/learning/pc/10.jpg'),
            video: 'https://static-c.ajinga.com/nestle/NHS.mp4',
            title: 'onboarding.nestle.learningPage.nestleHealthScience',
            subtitle: '',
            showVideoImage: true,
            videoSubTitles: []
          }
        ],
        customImgs: [
          {
            img: require(isMobile ? '@/assets/image/onboarding/learning/h5/11.jpg' : '@/assets/image/onboarding/learning/pc/11.jpg'),
            link: 'https://static-c.ajinga.com/nestle/NHS_IntroductionGlobalOnboarding.pdf',
            title: 'onboarding.nestle.learningPage.messageFromGregBehar',
            subtitle: '',
            isVuePage: false
          }
        ]
      },
      customVideosAndImg5: {
        customVideos: [],
        customImgs: [
          {
            img: require(isMobile ? '@/assets/image/onboarding/learning/h5/6.jpg' : '@/assets/image/onboarding/learning/pc/6.jpg'),
            link: `/onboarding/${this.$route.params.invitationId}/nestle/nespresso`,
            title: 'onboarding.nestle.learningPage.nestleNespresso',
            subtitle: '',
            isVuePage: true
          }
        ]
      }
    }
  },
  computed: {
    welcomeModal () {
      return {
        title: this.$t('onboarding.nestle.landingPage.welcomeTitle'),
        body: this.$t('onboarding.nestle.landingPage.welcomeBody'),
        footer: [
          { text: this.$t('onboarding.nestle.landingPage.welcomeDontShow'), event: this.dontShowAgain, type: 'gray' },
          { text: this.$t('onboarding.nestle.landingPage.welcomeCompletePaperwork'), event: this.toPaperwork, type: 'normal' }
        ]
      }
    }
  },
  async created () {
    if (deviceType.isWeChat) {
      if (this.$route.query.code !== undefined && this.$route.query.code !== '') {
      }
    }
    const hideWelcome = localStorage.getItem('hideWelcome') || false
    this.showWelcome = !hideWelcome
    const invitationInfo = this.$parent.invitationInfo
    if (invitationInfo) {
      const divCode = invitationInfo.div_code
      switch (divCode) {
        case '10000006':
          this.customVideosAndImg = this.customVideosAndImg1
          break
        case '10000000':
          this.customVideosAndImg = this.customVideosAndImg2
          break
        case '10000003':
          this.customVideosAndImg = this.customVideosAndImg3
          break
        case '10000009':
          this.customVideosAndImg = this.customVideosAndImg4
          break
        case '10000012':
          this.customVideosAndImg = this.customVideosAndImg5
          break
        default:
          break
      }
    }
  },
  methods: {
    dontShowAgain () {
      localStorage.setItem('hideWelcome', true)
      this.showWelcome = false
    },
    toPaperwork () {
      this.$router.push(`/onboarding/${this.invitationId}/nestle/paperwork-home`)
    },
    toPage (name) {
      if (name === 'paperwork') {
        this.$router.push(`/onboarding/${this.invitationId}/nestle/paperwork-home`)
      } else if (name === 'myFirstDay') {
        this.$router.push(`/onboarding/${this.invitationId}/nestle/my-first-day`)
      } else if (name === 'learning') {
        this.$router.push(`/onboarding/${this.invitationId}/nestle/learning`)
      }
    },
    playVideo (index) {
      if (index !== undefined) {
        this.customVideosAndImg.customVideos[index].showVideoImage = false
        this.$refs.customVideos[index].play()
      } else {
        this.showVideoImage = false
        this.$refs.video.play()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/onboarding-common.scss';
@import '@/assets/scss/onboarding-static-page.scss';

.onboarding-static-page-container {
  .header {
    background-image: url('~@/assets/image/onboarding/landing/h5/banner.jpg');
  }
}

/* 中型设备（台式电脑） */
@media (min-width: 769px) {
  .onboarding-static-page-container {
    .header {
      background-image: url('~@/assets/image/onboarding/landing/pc/banner.jpg');
      justify-content: flex-end;
    }
  }
}
</style>
